<script lang="ts">
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Services
	import { format } from '../../../../services/i18n';
	import { localReq, postReq } from '../../../../services/http';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Types
	import type { InputClickEvent } from '../../../../types/InputClickEvent';
	//Design system components
	import { Toggle, Alert, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	let settings = readDeviceSettings(id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore ?? settings;

	let loading = false;

	let localIp = get_local_ip(id);

	let reverse = settings[device.category + 's'][device.channel].swap_inputs;
	//TODO this need to be abstracted, because only difference is url which is used for request

	const sentRequest = async (e: InputClickEvent) => {
		let res;
		loading = true;
		reverse = e.target.checked;
		if (localIp) {
			res = await localReq(device, `${localIp}/settings/relay/0`, 'post', {
				swap_inputs: reverse ? 1 : 0,
			});
		} else {
			res = await postReq(`/device/light/settings/swap_inputs`, {
				id: id,
				channel: device.channel,
				swap_inputs: reverse ? 1 : 0,
			});
		}

		if (res.isok) {
			settings[device.category + 's'][device.channel].swap_inputs = reverse;
			devices_settings.update_devices_settings(id, settings);
			toast.open({
				type: 'success',
				title: $format('swap_inputs_scc_toast', {
					default: `Inputs was swapped.`,
				}),
			});
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
			reverse = !reverse;
		}
		loading = false;
	};
</script>

<Toggle
	class="mb-s"
	size="m"
	disabled={loading}
	checked={reverse}
	on:click={sentRequest}
	id="toggle-2uqsk9c"
>
	{$format('enable', {
		default: 'Enable',
	})}
</Toggle>

<Alert
	heading={$format('option_reverse_buttons', {
		default: 'If you enable this option, button 1 and 2 will be swapped.',
	})}
/>
